import { render, staticRenderFns } from "./AttrsContainer.vue?vue&type=template&id=41a05ac8&scoped=true"
import script from "./AttrsContainer.vue?vue&type=script&lang=js"
export * from "./AttrsContainer.vue?vue&type=script&lang=js"
import style0 from "./AttrsContainer.vue?vue&type=style&index=0&id=41a05ac8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41a05ac8",
  null
  
)

export default component.exports